import {
  filterVar,
} from './variables';

export const localFilter = () => {
  return filterVar();
}